/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { CompanyType } from '@well/common-libs/legal-entity-management/domain-model';

@Component({
  selector: 'well-account-type',
  templateUrl: './account-type.component.html',
  styleUrls: ['./account-type.component.scss'],
})
export class AccountTypeComponent implements OnInit {

  @Input() color = '';

  @Input() iconClass = '';

  @Input() description = '';

  @Input() title = '';

  @Input() type: CompanyType = CompanyType.customer;

  @Output() nextStep: EventEmitter<CompanyType> = new EventEmitter<CompanyType>();

  constructor() {
  }

  ngOnInit(): void {
  }

  goToNextStep() {
    this.nextStep.emit(this.type);
  }
}
